<mat-toolbar color="accent">Prior Approval Attachments</mat-toolbar>

<div class="p-4">
  <mat-selection-list [formControl]="selectedCtrl" [compareWith]="compareFn">
    @for (attachment of attachments; track attachment.ref.path) {
      <mat-list-option [value]="attachment">
        <mat-icon matListItemIcon>
          {{ attachment.type | map: getIcon }}
        </mat-icon>

        <div matListItemTitle>{{ attachment.name }}</div>
        <div matListItemLine class="text-sm text-gray-500">
          {{ attachment.type }}
        </div>
      </mat-list-option>
      <mat-divider />
    }
  </mat-selection-list>

  <pt-buttons-container>
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!selectedCtrl.value.length"
      (click)="dialogRef.close(selectedCtrl.value)"
    >
      Attach {{ selectedCtrl.value.length || '' }}
    </button>
  </pt-buttons-container>
</div>
